<template>
  <v-card outlined class="pa-4 petmed-business-line">
    <span class="pw-section d-block mb-3">Atenciones por línea de negocio</span>

    <div v-if="loading" class="state-msg py-10 text-center">
      <v-progress-circular indeterminate size="24" width="2" color="primary" />
    </div>
    <div v-else-if="error" class="state-msg py-10 text-center">
      <v-icon small color="error" class="mr-1">mdi-alert-circle-outline</v-icon>
      No se pudo cargar el detalle por línea de negocio.
    </div>
    <div v-else-if="attendances === 0" class="state-msg py-10 text-center">
      Sin atenciones en el período
    </div>
    <template v-else>
      <div class="d-flex flex-wrap line-legend mb-3">
        <div v-for="line in lines" :key="line.key">
          <span class="pw-label d-flex align-center">
            <span class="legend-dot" :class="`legend-dot--${line.key}`" />
            {{ line.label }}
          </span>
          <div class="pw-kpi">{{ line.percentageLabel }}</div>
          <span class="pw-pct">{{ line.attendances }} atenciones</span>
        </div>
      </div>
      <div v-if="segments.length > 0" class="bl-bar" role="img" :aria-label="barAria">
        <div
          v-for="line in segments"
          :key="line.key"
          class="bl-segment"
          :class="`bl-segment--${line.key}`"
          :style="{ width: `${line.percentage}%` }"
        />
      </div>
    </template>
  </v-card>
</template>

<script>
import { businessLineShare, shareLabel } from '@/utils/petmed-metrics.utils';

export default {
  name: 'PetmedBusinessLineBreakdown',

  props: {
    // insights.byBusinessLine del contrato
    byBusinessLine: { type: Object, default: () => ({}) },
    // totals.attendances: decide el estado vacío, como en las demás cards
    attendances: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
  },

  computed: {
    lines() {
      return businessLineShare(this.byBusinessLine).map((l) => ({ ...l, percentageLabel: shareLabel(l.percentage) }));
    },
    // Solo las líneas con atenciones: un segmento de ancho 0 igual pinta su
    // borde separador. Sin ninguna (backend sin el desglose) no hay barra.
    segments() {
      return this.lines.filter((l) => l.attendances > 0);
    },
    barAria() {
      return this.lines.map((l) => `${l.label} ${l.percentageLabel}`).join(', ');
    },
  },
};
</script>

<style scoped>
.state-msg {
  font-size: 13px;
  color: var(--pw-text-muted);
}
.bl-bar {
  display: flex;
  height: 14px;
  border-radius: var(--pw-radius-control);
  overflow: hidden;
  background: var(--pw-divider);
}
.bl-segment {
  height: 100%;
}
.bl-segment:first-child {
  border-top-left-radius: var(--pw-radius-control);
  border-bottom-left-radius: var(--pw-radius-control);
}
.bl-segment:last-child {
  border-top-right-radius: var(--pw-radius-control);
  border-bottom-right-radius: var(--pw-radius-control);
}
.bl-segment + .bl-segment {
  border-left: 2px solid var(--pw-surface);
}
.bl-segment--b2c,
.legend-dot--b2c {
  background: var(--pw-primary);
}
.bl-segment--b2b2c,
.legend-dot--b2b2c {
  background: var(--pw-link);
}
.bl-segment--employeeBenefit,
.legend-dot--employeeBenefit {
  background: var(--pw-info);
}
.bl-segment--assistance,
.legend-dot--assistance {
  background: var(--pw-text-faint);
}
.bl-segment--other,
.legend-dot--other {
  background: var(--pw-border-strong);
}
.line-legend {
  gap: 32px;
}
.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 6px;
}
</style>
